import React from 'react';
import { Shield } from 'lucide-react';
import { AudioEffect, AudioEffectControlProps } from './AudioEffect';

export interface NoisegateConfig {}

class NoisegateEffectImpl extends AudioEffect<NoisegateConfig> {
  readonly id = 'noisegate';
  readonly label = 'Noise Gate';
  readonly icon = Shield;
  readonly description = 'Gate de bruit';
  readonly defaultConfig: NoisegateConfig = {};
  readonly disabled = true;
  readonly disabledReason = 'Bientôt disponible';

  renderControls(_props: AudioEffectControlProps<NoisegateConfig>) {
    return (
      <div style={{ fontSize: 11, color: 'rgba(148,163,184,0.6)' }}>
        Gate de bruit — pas encore branché au pipeline audio.
      </div>
    );
  }
}

export const noisegateEffect = new NoisegateEffectImpl();
